import { IBook } from './types';
import { getBookTextInputData } from './inputs/text/utils';
import { getBookRadioInputData, getBookRadioInputOptionData } from './inputs/radio/utils';
import { getBookPriceData } from './prices/utils';
import { getBookSelectInputData, getBookSelectInputOptionData } from './inputs/select/utils';
import {
  BOOK_ALIAS_WELCOME_TO_THE_WOLD,
  INPUT_NAME_KIDS_NAME,
  INPUT_NAME_KIDS_BIRTHDAY,
  INPUT_NAME_HAIR_STYLE,
  INPUT_VALUE_HAIR_STYLE_STRAIGHT,
  INPUT_VALUE_HAIR_STYLE_CURL,
  INPUT_VALUE_PARENTS_MOM_AND_DAD,
  INPUT_VALUE_PARENTS_MOM_AND_MOM,
  INPUT_VALUE_PARENTS_DAD_AND_DAD,
  INPUT_VALUE_PARENTS_MOM,
  INPUT_VALUE_PARENTS_DAD,
  INPUT_NAME_PARENTS,
  BOOK_PRICE_WELCOME_TO_THE_WOLD,
  BOOK_PRICE_WELCOME_TO_THE_WOLD_HARD_COVER,
} from '@shared/book/constants';
import { EBookBannerTextColor } from './banner/types';
import { EBookDescriptionTextItemType } from './desicription/types';
import StaryDream from './StaryDream';
import { getBookDateInputData } from './inputs/date/utils';
import { getBookNameValidatorList } from 'src/app/validators';
import { GET_BOOK_NAME_ERROR } from 'src/app/validators.constants';
import { WhosBirthdayTomorrowInputsSeason } from './WhosBirthdayTomorrow';
import { EBookSelectInputType } from './inputs/select/types';

export const WelcomeToTheWorldInputsKidsName = getBookTextInputData({
  label: 'Kid’s name',
  placeholder: 'ひらがな８文字まで',
  // value: '',
  name: INPUT_NAME_KIDS_NAME,
  validator: getBookNameValidatorList(8),
  error: GET_BOOK_NAME_ERROR(8),
});

export const WelcomeToTheWorldInputsKidsBirthday = getBookDateInputData({
  label: 'Kid’s birthday',
  placeholder: 'yyyy/mm/dd',
  // value: new Date(),
  max: new Date(),
  name: INPUT_NAME_KIDS_BIRTHDAY,
});

export const WelcomeToTheWorldInputsHairStyle = getBookRadioInputData({
  label: 'Hair style',
  options: [
    getBookRadioInputOptionData({
      label: 'Straight',
      imgSrc: '/assets/images/radio-straight.png',
      value: INPUT_VALUE_HAIR_STYLE_STRAIGHT,
    }),
    getBookRadioInputOptionData({
      label: 'Curl',
      imgSrc: '/assets/images/radio-curl.png',
      value: INPUT_VALUE_HAIR_STYLE_CURL,
    }),
  ],
  value: INPUT_VALUE_HAIR_STYLE_STRAIGHT,
  name: INPUT_NAME_HAIR_STYLE,
});

export const WelcomeToTheWorldInputsParents = getBookSelectInputData({
  selectType: EBookSelectInputType.imageText,
  label: 'Parents',
  placeholder: 'Please choose',
  options: [
    getBookSelectInputOptionData({
      label: 'Mom and Dad',
      imgSrc: '/assets/images/parents/mom-dad.png',
      value: INPUT_VALUE_PARENTS_MOM_AND_DAD,
    }),
    getBookSelectInputOptionData({
      label: 'Mom and Mom',
      imgSrc: '/assets/images/parents/mom-mom.png',
      value: INPUT_VALUE_PARENTS_MOM_AND_MOM,
    }),
    getBookSelectInputOptionData({
      label: 'Dad and Dad',
      imgSrc: '/assets/images/parents/dad-dad.png',
      value: INPUT_VALUE_PARENTS_DAD_AND_DAD,
    }),
    getBookSelectInputOptionData({
      label: 'Mom',
      imgSrc: '/assets/images/parents/mom.png',
      value: INPUT_VALUE_PARENTS_MOM,
    }),
    getBookSelectInputOptionData({
      label: 'Dad',
      imgSrc: '/assets/images/parents/dad.png',
      value: INPUT_VALUE_PARENTS_DAD,
    }),
  ],
  // value: '',
  name: INPUT_NAME_PARENTS,
});

export const WelcomeToTheWorldInputsSeason = WhosBirthdayTomorrowInputsSeason;

const WelcomeToTheWorld: IBook = {
  caption: 'Welcome to the world',
  summary: [
    '出産の記念やお祝いに。',
    '１歳を迎える子への、最初の絵本としても。'],
  alias: BOOK_ALIAS_WELCOME_TO_THE_WOLD,
  prices: [
    ['soft', getBookPriceData(BOOK_PRICE_WELCOME_TO_THE_WOLD)],
    ['hard', getBookPriceData(BOOK_PRICE_WELCOME_TO_THE_WOLD_HARD_COVER)],
  ],
  photos: [
    '/assets/images/book3-carousel01.jpg',
    '/assets/images/book3-carousel02.jpg',
    '/assets/images/book3-carousel03.jpg',
  ],
  menuPhoto: '/assets/images/cart-product-photo-3.png',
  previewPhoto: '/assets/images/book3-books.png',
  properties: {
    purpose: ['Birth Gift'],
    age: {
      start: 0,
      end: 3,
    },
  },
  notice: {
    caption: 'Book new world',
    description: 'welcome.description',
    points: [
      {
        imgSrc: '/assets/images/welcome-notice-point-1.png',
        caption: 'welcome.notice.point.1',
      },
      {
        imgSrc: '/assets/images/welcome-notice-point-2.png',
        caption: 'welcome.notice.point.2',
      },
    ],
  },
  points: [
    {
      caption: 'どんなカスタムができるの？',
      description: '親の構成の選択、メッセージ編集、写真を入れるなど。お誕生日や出生時間でイラストが変化します。',
    },
    {
      caption: '絵本のストーリーは？',
      description: '主人公が着いたところは、どんなところ？たくさんの自然があり、命がある。そして何より、その子のことが大好きな人がいる。',
    },
    {
      caption: 'ページ数や絵本の大きさは？',
      description: '全26ページ、本文の大きさは幅29.7cm 高さ21cmのA4横。',
    },
  ],
  inputs: [
    WelcomeToTheWorldInputsKidsName,
    WelcomeToTheWorldInputsKidsBirthday,
    WelcomeToTheWorldInputsHairStyle,
    WelcomeToTheWorldInputsParents,
  ],
  banner: {
    imgSrc: '/assets/images/book3-banner-desktop.png',
    imgSrcLtMd: '/assets/images/book3-banner-mobile.png',
    text: 'まいにちが　だいぼうけん。　ここにある　まほうを　みつけよう。',
    textColor: EBookBannerTextColor.dark,
  },
  description: [
    {
      imgSrc: '/assets/images/book3-images01.gif',
      text: [
        {
          type: EBookDescriptionTextItemType.caption,
          text: 'いろんな家族の形があるから'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: '主人公のことをここで待っていたのは、ママとパパ？それともパパとパパ？'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: 'どんな形の家族でも、その子を大好きな気持ちは同じ。',
        },
      ],
    }, {
      imgSrc: '/assets/images/book3-images02.jpg',
      text: [
        {
          type: EBookDescriptionTextItemType.caption,
          text: '生まれた時の思い出を、絵本の１ページに'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: '絵本の最後のページには、主人公の写真を追加することができます。'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: 'お名前やお誕生日と一緒に、あの時の思い出を絵本に、ずっと。',
        },
      ],
    },
  ],
  reviews: StaryDream.reviews,
};

export default WelcomeToTheWorld;
